import React, { useCallback, useEffect } from "react";
import './Empty.scss';
import Spinner from "../Spinner/Spinner";
import { Button, Col, Container, Row } from "react-bootstrap";
import nvCookieHelpers from "../../services/cookieService";
import { useHeaderMenu } from "../../contexts/login.context";
import useLoader from "../../contexts/LoaderContext";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../services/authService";
import { useLocation } from "react-router-dom";
import { useLocalization } from '../../contexts/LocalizationContext';
const Empty = () => {
    const { setLoginStatus, setItemsInCart } = useHeaderMenu();
    const { InvalidateCheckoutSession } = useAuth();
    const { t } = useTranslation();
    const { state } = useLocation();
    const msgString = (state?.msg) ? (state?.msg) : t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY');
    const productId = (state?.pid) ? (state?.pid) : 0;
    const { isLoading, showLoader, hideLoader } = useLoader();
    const { locale } = useLocalization();
    //const locale = window.location.pathname.split('/')[1];
    // let cookieItem = { cart: [], lastAction: null };
    let orderObj = nvCookieHelpers.getCookie('nvHeadless');
    setItemsInCart(0);
    sessionStorage.removeItem('type');
    sessionStorage.removeItem('guest');
    sessionStorage.removeItem('customer');
    sessionStorage.removeItem('loggedIn');
    sessionStorage.removeItem('register');
    sessionStorage.removeItem('isShipping');
    nvCookieHelpers.deleteCookie('checkout');
    sessionStorage.removeItem('checkoutClicked');
    nvCookieHelpers.deleteCookie('sessionDetails');
    const handleSessionInvalidateSuccess = useCallback(() => {
        console.log('Logged Out!');
        const isUserLoggedInCookie = nvCookieHelpers.getCookie('isUserLoggedIn');
        if (isUserLoggedInCookie && isUserLoggedInCookie !== '') {
            setLoginStatus(JSON.parse(isUserLoggedInCookie));
            sessionStorage.setItem('loggedIn', 'true');
        } else {
            sessionStorage.removeItem('loggedIn');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSessionInvalidateError = useCallback(() => {
        console.log('Logged Out!');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const invalidateSession = () => {
        showLoader();
        try {
            InvalidateCheckoutSession(handleSessionInvalidateSuccess, handleSessionInvalidateError);
            setLoginStatus(false)
            hideLoader();
        } catch (error) {
            hideLoader();
        }
    }
    useEffect(() => {
        let tmpcart = orderObj ? orderObj['cart'] : [];
        if (tmpcart && tmpcart.length) {
            if (productId) {
                tmpcart = tmpcart.filter(item => productId !== item.id);
            }
            if (orderObj && orderObj['activeTab']) {
                tmpcart = tmpcart.filter(item => orderObj['activeTab'] !== item.category);
            }
        }

        if (orderObj && tmpcart) {
            orderObj['cart'] = tmpcart;
            console.log('tmpcart==>', tmpcart);
            nvCookieHelpers.setCookie('nvHeadless', JSON.stringify(orderObj));
        } else {
            let updatedCart = { cart: tmpcart, lastAction: null };
            nvCookieHelpers.setCookie('nvHeadless', JSON.stringify(updatedCart));
        }
        invalidateSession();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const returnStore = () => {
        // showLoader();
        // const storedCookie = nvCookieHelpers.getCookie('store');
        const decodedURL = locale === 'en-hk' ? 'https://www.nvidia.cn/geforce/' : locale === 'en-ph' ? 'https://marketplace.nvidia.com/en-ph/consumer/' : locale === 'en-af' ? 'https://marketplace.nvidia.com/en-eu/consumer/' : `https://marketplace.nvidia.com/${locale === 'en-me' ? 'en-us' : locale}`;
        if (decodedURL && decodedURL !== '') {
            window.location.href = decodedURL;
        }
    }
    return (
        <div className="EmptyCart">
            {isLoading ? (
                <Spinner />
            ) : (
                <Container>
                    <Row xs={'auto'} md={'auto'}>
                        <Col md={12}>
                            <p className="dr_emptyCart">{msgString}</p>
                            <Button className="storeCTA" onClick={returnStore}>{t('BTN_CONTINUE_SHOPPING')}</Button>
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    )
}

export default Empty;